import {
  // queryStaffApi,
  getRoleFunctionListApi,
  setRoleFunctionApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  查询员工列表信息接口
  // async queryStaffAction(context, param) {
  //   const res = await queryStaffApi(param)
  //   return res
  // },
  // 获取员工权限
  async getRoleFunctionListAction(context, param) {
    const res = await getRoleFunctionListApi(param)
    return res
  },
  // 保存角色功能关系
  async setRoleFunctionAction(context, param) {
    const res = await setRoleFunctionApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
